export default __webpack_public_path__ + "static/img-art-pandas-profiling-2-cedf196653ec3a1de98297c4118ac0dd.webp";